import Button from '@mui/material/Button';
import styled from 'styled-components';

export const StyledTryAgainButton = styled(Button)`
    border-radius: 3px;
    border: 1px solid #d6d6d6;
    background: #ffffff;
    color: #5b5b5b;
    &:hover {
        background: #ffffff;
        color: #5b5b5b;
    }
`;

export const StyledContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
`;

export const StyledTitleSteps = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

export const StyledTitleStepsMain = styled.div`
    height: 100%;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    display: inline-flex;
    padding-right: 10px;
`;

export const StyledTitleStepsMainDiv = styled.div`
    margin-top: 40px;
    justify-content: center;
    align-items: center;
    gap: 12px;
    display: flex;
`;

export const IconContainer = styled.div`
    text-align: center;
    color: #4c17ad;
    font-size: 16px;
    font-family: Font Awesome 6 Pro;
    font-weight: 400;
    word-wrap: break-word;
`;

export const IconMainDiv = styled.div`
    width: 16px;
    justify-content: center;
    align-items: center;
    display: flex;
`;
